/* unplugin-vue-components disabled */import script from "./RecommendArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendArticle.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendArticle.vue?vue&type=style&index=0&id=3bf3ff8a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf3ff8a"]])

export default __exports__